








import EventRemoteComponent from "@/components/admin/eventRemote/eventRemoteComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "EventRemotePage",
  components: {
    EventRemoteComponent,
  },
})
export default class EventRemotePage extends Vue {}
